import { react, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import LoadingIndicator from '../LoadingIndicator'
import TokenService from '../../services/TokenService';

export default function VerifyPhoneNumber(props) {
    const handleClose = () => {
        props.Close(false);
        //setisShown(false);
    };
    const [state, setState] = useState('Send');
    const [phoneNumber, setPhoneNumber] = useState(props.PhoneNumber == null ? '' : props.PhoneNumber);
    const [validationNumber, setValidationNumber] = useState('');


    function sendAccessCode() {
        // send to server
        TokenService.post('', 'Returner_PhoneNumber_GenerateKey')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {

                   
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
        setState('Verify');
      
    }

    function handleVerify() {
        let postData = {
            validationCode: validationNumber
        }
        TokenService.post(postData, 'Returner_PhoneNumber_ValidateKey')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    let level = JSON.parse(jsonData.ReturnerLevel);
                    let event = new CustomEvent('ReturnerLevel_Updated', {
                        detail: level
                    });
                    document.getElementsByTagName('body')[0].dispatchEvent(event);
                    props.Close(true);
                }
                else {
                    setState('Invalid');
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
        setState('Validating');
        //Returner_PhoneNumber_ValidateKey
    }

    function buildSendDialog() {
        return <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Verify your Phone Number
                </DialogTitle>
                <DialogContent>

                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection:'column' }}>
                        <div style={{ fontSize: '14pt', alignSelf:'center', fontWeight:'bold' }}>{phoneNumber }</div>
                        <div style={{ alignSelf: 'center', marginTop:'10px' } }>Then press Send Access Code</div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="sipzeeGreen" onClick={sendAccessCode} autoFocus>
                       Send Access Code
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    }

    function buildVerifyDialog() {
        return <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Verify your Phone Number
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <div style={{ alignSelf: 'center' }}>
                            Please enter the Access Code you received in your text message.
                        </div>
                        <div style={{ alignSelf: 'center', marginTop:'10px' }}>
                            <TextField style={{ width: '200px', alignSelf: 'flex-start' }} label="Access Code" onChange={(e) => setValidationNumber(e.target.value)} value={validationNumber} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={handleVerify} variant="contained" color="sipzeeGreen" autoFocus>
                        Verify
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    }

    function buildLoading() {
        return <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <LoadingIndicator Message='Verifying' />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={handleVerify} disabled variant="contained" color="sipzeeGreen" autoFocus>
                        Verify
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    }

    function buildInvalidEntry() {
        return <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Invalid Access Code
                </DialogTitle>
                <DialogContent>
                   <div>This was not the correct Access Code</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    }

    if (state == 'Send') {
        return buildSendDialog();
    }
    else if (state == 'Verify') {
        return buildVerifyDialog();
    }
    else if (state == 'Validating') {
        return buildLoading();
    }
    else if (state == 'Invalid') {
        return buildInvalidEntry();
    }


}